/* Home F7: navegação estática em Liquid, hero Galeria A e Roupas pelo motor compartilhado. */
(function () {
  'use strict';
  const temTexto = (v) => typeof v === 'string' && v.trim() !== '';
  const ORDEM = ['categoria', 'subcategoria', 'marca', 'genero'];
  function hrefFiltros(param, filtros, base = '/collections/all') {
    const pares = [];
    for (const k of ORDEM) {
      if (!Object.prototype.hasOwnProperty.call(filtros || {}, k)) continue;
      if (!temTexto(param && param[k]) || !temTexto(filtros[k])) return null;
      pares.push(encodeURIComponent(param[k].trim()) + '=' + encodeURIComponent(filtros[k]));
    }
    return pares.length ? base + '?' + pares.join('&') : null;
  }
  function juntarProdutos(resumo, liquid) {
    const porHandle = new Map((liquid || []).map((p) => [p.handle, p]));
    (resumo || []).forEach((p) => porHandle.set(p.handle, p));
    return [...porHandle.values()];
  }
  function pecasDaAba(V, aba, linhas = V.estoque, limite = 8) {
    const lista = linhas.filter((p) => p.categoria === 'Roupas' && V.marcaCurta(p.marca) === aba.marca);
    return [true, false].flatMap((estado) => V.intercala(V.porRank(lista.filter((p) => p.disponivel === estado)))).slice(0, limite);
  }
  function roupas(V, param, linhas = V.estoque, base) {
    const atuais = V.dadosRoupas(), grupos = new Map();
    const pecas = linhas.filter((p) => p.categoria === 'Roupas');
    pecas.forEach((p) => {
      const marca = V.marcaCurta(p.marca);
      grupos.set(marca, (grupos.get(marca) || 0) + 1);
    });
    const abas = [...grupos].filter(([, n]) => n >= 5).map(([marca, n]) => ({ marca, n }))
      .sort((a, b) => Number(b.marca === V.cfg.abaPadraoRoupas) - Number(a.marca === V.cfg.abaPadraoRoupas) || b.n - a.n
        || atuais.abas.findIndex((x) => x.marca === a.marca) - atuais.abas.findIndex((x) => x.marca === b.marca));
    const hrefTodas = hrefFiltros(param, { categoria: 'Roupas' }, base);
    if (!abas.length || !hrefTodas) return null;
    const generos = ['Feminino', 'Masculino', 'Unissex'].filter((g) => pecas.some((p) => p.genero === g))
      .map((g) => ({ g, href: hrefFiltros(param, { categoria: 'Roupas', genero: g }, base) })).filter((g) => g.href);
    return { abas, generos, hrefTodas };
  }
  const HitHome = Object.freeze({ hrefFiltros, pecasDaAba, roupas, juntarProdutos });
  if (typeof module !== 'undefined') module.exports = HitHome;
  if (typeof window === 'undefined' || typeof document === 'undefined' || window.HitHome) return;
  window.HitHome = HitHome;
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const iniciados = new WeakSet();
  const heroes = new WeakMap();
  const blocos = new WeakMap();
  const reduz = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const configHome = () => {
    try { return JSON.parse(document.getElementById('home-config').textContent); } catch (_) { return {}; }
  };

  function hero(raiz) {
    const slides = $$('[data-home-slide]', raiz), barra = raiz.querySelector('[data-home-controles]');
    const toggle = raiz.querySelector('[data-hero-toggle]');
    if (slides.length < 2 || !barra || !toggle) {
      if (barra) { barra.hidden = true; barra.querySelector('[data-hero-seletores]')?.replaceChildren(); }
      if (toggle) toggle.hidden = true;
      return () => {};
    }
    const seletores = barra.querySelector('[data-hero-seletores]');
    const painel = raiz.querySelector('.home-hero-painel');
    const marco = raiz.querySelector('[data-hero-reading-start]') || raiz;
    const movimento = window.matchMedia('(prefers-reduced-motion: reduce)');
    const duracao = 6000, descartes = [], camadas = new Set();
    let ativo = Math.max(0, slides.findIndex((s) => !s.hidden));
    let usuarioPausou = movimento.matches || raiz.dataset.homeUserPaused === 'true' || !!window.Shopify?.designMode, mouseDentro = false, visivel = false, destruido = false;
    let restante = duracao, prazo = 0, relogio = 0, quadro = 0, inicio = null, bloquearClique = false;
    let observador, medidas, cabecalho;
    function escuta(alvo, tipo, fn, opcoes) {
      alvo.addEventListener(tipo, fn, opcoes);
      descartes.push(() => alvo.removeEventListener(tipo, fn, opcoes));
    }
    function medeVisibilidade() {
      const r = raiz.getBoundingClientRect(), m = marco.getBoundingClientRect();
      const cab = document.getElementById('cab'), nav = document.getElementById('nav-m');
      const css = getComputedStyle(document.documentElement);
      const topo = cab ? Math.max(0, cab.getBoundingClientRect().bottom) : parseFloat(css.getPropertyValue('--h-topo')) || 0;
      const baixo = nav ? Math.max(0, nav.getBoundingClientRect().height) : parseFloat(css.getPropertyValue('--h-baixo')) || 0;
      const fim = window.innerHeight - baixo;
      const parte = Math.max(0, Math.min(r.bottom, fim) - Math.max(r.top, topo));
      // O começo da peça precisa continuar visível abaixo do cabeçalho.
      // Assim a troca não move o conteúdo seguinte depois que o leitor já começou a rolar.
      visivel = r.width > 0 && r.height > 0 && m.top >= topo - 1 && m.top < fim &&
        parte >= r.height * .6;
    }
    function cabecalhoAberto() {
      const cab = document.getElementById('cab');
      return !!cab && $$('.menu-painel:not([hidden]), .busca-res:not([hidden])', cab).some((el) =>
        el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden');
    }
    function pausado() {
      return usuarioPausou || mouseDentro || !!inicio || document.hidden || !visivel || camadas.size > 0 || cabecalhoAberto() ||
        !!document.querySelector('[role="dialog"].on[aria-modal="true"], dialog[open]') ||
        (raiz.contains(document.activeElement) && document.activeElement !== toggle);
    }
    function pinta() {
      raiz.dataset.playback = pausado() ? 'paused' : 'playing';
      raiz.dataset.homeUserPaused = String(usuarioPausou);
      const texto = usuarioPausou ? 'Retomar' : 'Pausar';
      const rotulo = toggle.querySelector('[data-hero-toggle-label]');
      if (rotulo) rotulo.textContent = texto; else toggle.textContent = texto;
      toggle.setAttribute('aria-label', texto + ' troca automática de campanhas');
    }
    function paraRelogio() {
      if (!relogio) return;
      restante = Math.max(0, prazo - performance.now());
      clearTimeout(relogio); relogio = 0;
    }
    function sincroniza() {
      if (destruido) return;
      medeVisibilidade();
      if (pausado()) paraRelogio();
      else if (!relogio) {
        prazo = performance.now() + restante;
        relogio = setTimeout(() => {
          relogio = 0;
          medeVisibilidade();
          if (pausado()) { restante = 0; pinta(); return; }
          abre(ativo + 1);
          restante = duracao;
          sincroniza();
        }, restante);
      }
      pinta();
    }
    function reinicia() {
      if (relogio) clearTimeout(relogio);
      relogio = 0; restante = duracao;
      sincroniza();
    }
    function agendaMedida() {
      if (destruido || quadro) return;
      quadro = requestAnimationFrame(() => { quadro = 0; sincroniza(); });
    }
    seletores.replaceChildren();
    const botoes = slides.map((slide, i) => {
      const botao = document.createElement('button');
      botao.type = 'button'; botao.className = 'home-hero-seletor';
      botao.setAttribute('aria-label', slide.dataset.nome + ' — campanha ' + (i + 1) + ' de ' + slides.length);
      botao.setAttribute('aria-controls', slide.id);
      escuta(botao, 'click', () => { abre(i); reinicia(); });
      seletores.appendChild(botao);
      return botao;
    });
    function abre(indice, animar = true) {
      ativo = (indice + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== ativo; slide.inert = i !== ativo;
        if (i === ativo) slide.removeAttribute('inert'); else slide.setAttribute('inert', '');
      });
      botoes.forEach((botao, i) => botao.setAttribute('aria-current', String(i === ativo)));
      if (animar && !movimento.matches && slides[ativo].animate) slides[ativo].animate([{ opacity: 0 }, { opacity: 1 }], { duration: 240, easing: 'cubic-bezier(.16,.1,.3,1)' });
    }
    escuta(toggle, 'click', () => { usuarioPausou = !usuarioPausou; sincroniza(); });
    escuta(raiz, 'focusin', (ev) => { if (ev.target !== toggle) usuarioPausou = true; sincroniza(); });
    escuta(raiz, 'focusout', () => queueMicrotask(sincroniza));
    escuta(raiz, 'pointerenter', (ev) => { if (ev.pointerType === 'mouse') { mouseDentro = true; sincroniza(); } });
    escuta(raiz, 'pointerleave', (ev) => { if (ev.pointerType === 'mouse') { mouseDentro = false; sincroniza(); } });
    escuta(document, 'visibilitychange', sincroniza);
    escuta(document, 'hit:camada-abriu', (ev) => { camadas.add(ev.target); sincroniza(); });
    escuta(document, 'hit:camada-fechou', (ev) => { camadas.delete(ev.target); sincroniza(); });
    escuta(movimento, 'change', () => { if (movimento.matches) usuarioPausou = true; sincroniza(); });
    escuta(window, 'scroll', agendaMedida, { passive: true });
    escuta(window, 'resize', agendaMedida, { passive: true });
    escuta(raiz, 'shopify:block:select', (ev) => {
      const i = slides.findIndex((slide) => slide.dataset.blockId === ev.detail.blockId);
      if (i < 0) return;
      usuarioPausou = true; abre(i, false); reinicia();
    });
    escuta(painel, 'pointerdown', (ev) => {
      if (!ev.isPrimary || ev.button > 0) return;
      inicio = { x: ev.clientX, y: ev.clientY, id: ev.pointerId }; bloquearClique = false;
      sincroniza();
    });
    // Toque tem captura implícita; mouse e caneta também podem terminar fora do painel.
    escuta(window, 'pointerup', (ev) => {
      if (!inicio || inicio.id !== ev.pointerId) return;
      const dx = ev.clientX - inicio.x, dy = ev.clientY - inicio.y;
      inicio = null;
      if (Math.abs(dx) < 50 || Math.abs(dx) <= Math.abs(dy)) { sincroniza(); return; }
      bloquearClique = true;
      const proximo = (ativo + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
      if (slides[ativo].contains(document.activeElement)) botoes[proximo].focus({ preventScroll: true });
      abre(proximo); reinicia();
    });
    escuta(window, 'pointercancel', (ev) => {
      if (!inicio || inicio.id !== ev.pointerId) return;
      inicio = null; sincroniza();
    });
    escuta(window, 'blur', () => { inicio = null; sincroniza(); });
    escuta(window, 'click', (ev) => {
      if (!bloquearClique) return;
      bloquearClique = false;
      if (ev.detail > 0 && painel.contains(ev.target)) { ev.preventDefault(); ev.stopPropagation(); }
    }, true);
    if (window.IntersectionObserver) {
      observador = new IntersectionObserver(agendaMedida, { threshold: [0, .6, 1] });
      observador.observe(raiz); observador.observe(marco);
    }
    if (window.ResizeObserver) {
      medidas = new ResizeObserver(agendaMedida);
      [raiz, document.getElementById('cab'), document.getElementById('nav-m')].filter(Boolean).forEach((el) => medidas.observe(el));
    }
    const cab = document.getElementById('cab');
    if (cab && window.MutationObserver) {
      // Menu e sugestões desktop não passam pelo HitCamadas.
      cabecalho = new MutationObserver(sincroniza);
      cabecalho.observe(cab, { attributes: true, subtree: true, attributeFilter: ['hidden', 'aria-expanded'] });
    }
    barra.hidden = false; toggle.hidden = false;
    abre(ativo, false); sincroniza();
    return () => {
      destruido = true;
      clearTimeout(relogio); cancelAnimationFrame(quadro);
      observador?.disconnect(); medidas?.disconnect(); cabecalho?.disconnect();
      descartes.forEach((descarta) => descarta());
    };
  }

  function trilhos(onde) {
    $$('[data-home-setas]', onde).forEach((barra) => {
      if (iniciados.has(barra)) return;
      const t = document.getElementById(barra.dataset.homeSetas);
      if (!t || t.classList.contains('home-produtos-grade')) return;
      iniciados.add(barra);
      const botoes = $$('[data-home-passo]', barra);
      let regua = t.nextElementSibling;
      if (!regua || !regua.classList.contains('regua')) {
        regua = document.createElement('div'); regua.className = 'regua'; regua.setAttribute('aria-hidden', 'true');
        regua.appendChild(document.createElement('i')); t.after(regua);
      }
      function mede() {
        const max = Math.max(0, t.scrollWidth - t.clientWidth), x = t.scrollLeft;
        barra.hidden = max <= 2;
        regua.hidden = max <= 2;
        if (max > 2) {
          const fracao = t.clientWidth / t.scrollWidth;
          regua.firstElementChild.style.width = (fracao * 100) + '%';
          regua.firstElementChild.style.left = (x / max * (1 - fracao) * 100) + '%';
          t.tabIndex = 0;
        } else t.removeAttribute('tabindex');
        botoes.forEach((b) => b.setAttribute('aria-disabled', String(Number(b.dataset.homePasso) < 0 ? x <= 2 : x >= max - 2)));
      }
      botoes.forEach((b) => b.addEventListener('click', () => {
        if (b.getAttribute('aria-disabled') === 'true') return;
        t.scrollBy({ left: Number(b.dataset.homePasso) * t.clientWidth, behavior: 'auto' });
        mede();
      }));
      t.addEventListener('scroll', mede, { passive: true });
      t.addEventListener('load', mede, true);
      if (window.ResizeObserver) new window.ResizeObserver(mede).observe(t);
      else window.addEventListener('resize', mede);
      mede();
      barra._homeMedir = mede;
    });
    $$('[data-home-setas]', onde).forEach((barra) => { if (barra._homeMedir) barra._homeMedir(); });
  }

  function newsletter(form) {
    const erro = form.querySelector('.home-erro');
    $$('input[required]', form).forEach((campo) => {
      campo.addEventListener('invalid', () => {
        campo.setCustomValidity(campo.dataset.erro);
        campo.setAttribute('aria-invalid', 'true');
        erro.textContent = campo.dataset.erro; erro.hidden = false;
      });
      campo.addEventListener('input', () => {
        campo.setCustomValidity(''); campo.removeAttribute('aria-invalid');
        erro.hidden = true;
      });
    });
    const sucesso = form.querySelector('[data-home-news-sucesso]');
    if (sucesso && location.hash === '#' + form.id) sucesso.focus();
  }

  function navegaRoupas(raiz, V, linhas, P) {
    const C = window.HitConfig, d = roupas(V, C.param, linhas, configHome().colecaoGeral);
    if (!d) { raiz.hidden = true; return; }
    const barra = raiz.querySelector('[data-roupas-abas]'), painel = raiz.querySelector('[data-roupas-painel]');
    const trilho = painel.querySelector('.home-produtos-grade'), instancia = raiz.dataset.instancia;
    const limite = Number(raiz.dataset.limiteProdutos) === 4 ? 4 : 8;
    let aberta = null;
    barra.replaceChildren();
    const botoes = d.abas.map((a, i) => {
      const b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'tab');
      b.id = 'roupas-aba-' + instancia + '-' + i; b.setAttribute('aria-controls', painel.id);
      b.textContent = window.HitVitrine.nomeDaMarca(a.marca);
      b.addEventListener('click', () => abre(a)); barra.appendChild(b);
      return b;
    });
    function abre(aba) {
      if (aba === aberta) return;
      aberta = aba;
      const indice = d.abas.indexOf(aba);
      botoes.forEach((b, i) => { b.setAttribute('aria-selected', String(i === indice)); b.tabIndex = i === indice ? 0 : -1; });
      painel.setAttribute('role', 'tabpanel'); painel.setAttribute('aria-labelledby', botoes[indice].id);
      trilho.innerHTML = pecasDaAba(V, aba, linhas, limite).map((p) => P.cardSolto(p)).join('');
      trilho.scrollLeft = 0;
      raiz.hidden = false;
      trilhos(raiz);
    }
    barra.onkeydown = (ev) => {
      const i = botoes.indexOf(ev.target);
      if (i < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(ev.key)) return;
      ev.preventDefault();
      const j = ev.key === 'Home' ? 0 : ev.key === 'End' ? botoes.length - 1 : (i + (ev.key === 'ArrowRight' ? 1 : -1) + botoes.length) % botoes.length;
      botoes.forEach((b, n) => { b.tabIndex = n === j ? 0 : -1; });
      botoes[j].focus();
    };
    const generos = raiz.querySelector('[data-roupas-generos]'); generos.replaceChildren();
    d.generos.forEach((g) => { const a = document.createElement('a'); a.className = 'home-link'; a.textContent = g.g; a.href = g.href; generos.appendChild(a); });
    barra.hidden = false;
    abre(d.abas[0]);
  }

  function imagensDoBloco(raiz, seletor) {
    const descartes = [];
    $$(seletor, raiz).forEach((img) => {
      const falhou = () => {
        const fallback = img.parentElement.querySelector('.brand-bubbles__fallback');
        if (fallback) { img.hidden = true; fallback.hidden = false; }
        else img.parentElement.hidden = true;
        img.closest('a')?.classList.add('is-missing');
      };
      img.addEventListener('error', falhou);
      if (img.complete && img.naturalWidth === 0) falhou();
      descartes.push(() => img.removeEventListener('error', falhou));
    });
    return () => descartes.forEach((fn) => fn());
  }

  function bubbles(raiz) {
    const rail = raiz.querySelector('.brand-bubbles__rail'), controls = raiz.querySelector('.brand-bubbles__controls');
    if (!rail || !controls) return () => {};
    const prev = controls.querySelector('[data-direction="-1"]'), next = controls.querySelector('[data-direction="1"]');
    const descartes = [imagensDoBloco(raiz, '.brand-bubbles__circle img')];
    const escuta = (alvo, evento, fn, opcoes) => { alvo.addEventListener(evento, fn, opcoes); descartes.push(() => alvo.removeEventListener(evento, fn, opcoes)); };
    const update = () => {
      [...rail.children].forEach((li) => { const hidden = !!li.querySelector('[data-home-marca]')?.hidden; if (li.hidden !== hidden) li.hidden = hidden; });
      const overflow = !rail.hidden && rail.scrollWidth - rail.clientWidth > 2;
      controls.hidden = !overflow;
      rail.classList.toggle('is-centered', !overflow);
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    };
    $$('.brand-bubbles__controls button', raiz).forEach((button) => escuta(button, 'click', () => {
      const first = [...rail.children].find((li) => !li.hidden);
      if (first) rail.scrollBy({ left: Number(button.dataset.direction) * (first.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0)), behavior: 'auto' });
      update();
    }));
    escuta(rail, 'focusin', (event) => {
      const entry = event.target.closest('.brand-bubbles__link'); if (!entry) return;
      const item = entry.getBoundingClientRect(), port = rail.getBoundingClientRect();
      const delta = item.left < port.left + 6 ? item.left - port.left - 6 : item.right > port.right - 6 ? item.right - port.right + 6 : 0;
      if (delta) rail.scrollBy({ left: delta, behavior: 'auto' });
    });
    escuta(rail, 'scroll', update, { passive: true });
    escuta(rail, 'load', update, true); escuta(rail, 'error', update, true); escuta(window, 'resize', update);
    if (window.ResizeObserver) { const observer = new ResizeObserver(update); observer.observe(rail); descartes.push(() => observer.disconnect()); }
    const observer = new MutationObserver(update); observer.observe(rail, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
    descartes.push(() => observer.disconnect()); update();
    return () => descartes.forEach((fn) => fn());
  }

  function campanhaRaquetes(slide) {
    const heading = slide.querySelector('.home-raquetes-copy h1,.home-raquetes-copy h2');
    if (!heading) return () => {};
    let destruido = false;
    const reflow = () => {
      if (destruido) return;
      const w = window.innerWidth, nominal = w < 360 ? 28 : w < 768 ? 32 : w < 1024 ? 38 : Math.min(56, Math.max(38, w * .038889));
      slide.classList.toggle('is-copy-expanded', parseFloat(getComputedStyle(heading).fontSize) > nominal * 1.35);
    };
    window.addEventListener('resize', reflow);
    const observer = window.ResizeObserver ? new ResizeObserver(reflow) : null; observer?.observe(heading);
    document.fonts?.ready.then(reflow); reflow();
    return () => { destruido = true; window.removeEventListener('resize', reflow); observer?.disconnect(); };
  }

  function completaNavegacao(linhas) {
    $$('[data-home-categorias]').forEach((raiz) => {
      $$('[data-home-categoria]', raiz).forEach((tile) => {
        if (tile.dataset.homeCurada === 'true') return;
        const produtos = linhas.filter((p) => p.categoria === tile.dataset.homeCategoria);
        if (!produtos.length) return; // O fallback também conhece produtos esgotados ausentes do resumo atual.
        tile.hidden = false;
        const foto = tile.querySelector('.home-categoria-foto');
        const capa = produtos.find((p) => p.disponivel && p.foto) || produtos.find((p) => p.foto);
        if (!foto.hasAttribute('data-curada') && capa) {
          const img = document.createElement('img'); img.src = capa.foto; img.alt = ''; img.loading = 'lazy'; img.width = 540; img.height = 675;
          foto.replaceChildren(img);
        }
        $$('[data-home-subcategoria]', tile).forEach((a) => { if (produtos.some((p) => p.subcategoria === a.dataset.homeSubcategoria)) a.hidden = false; });
      });
      raiz.hidden = !$$('[data-home-categoria]', raiz).some((t) => !t.hidden);
      trilhos(raiz);
    });
  }

  function quandoVisivel(raiz, carrega) {
    if (window.IntersectionObserver) {
      const o = new window.IntersectionObserver((entradas) => {
        if (entradas.some((e) => e.isIntersecting)) { o.disconnect(); carrega(); }
      }, { rootMargin: '800px' });
      o.observe(raiz.parentElement);
    } else carrega();
  }

  function iniciaRoupas(raiz) {
    const C = window.HitConfig;
    if (!C || !window.HitVitrine || !window.HitPecas) return;
    let liquid;
    try { liquid = JSON.parse(raiz.querySelector('[data-roupas-liquid]').textContent); } catch (_) { return; }
    const desenha = (resumo) => {
      const V = window.HitVitrine.criar(resumo, C.vitrine);
      const linhas = juntarProdutos(resumo, liquid);
      const home = configHome();
      const P = window.HitPecas.criar({ parcela: C.parcela, textos: home.textos, pix: home.pix, whatsapp: home.whatsapp, raiz: home.raiz });
      navegaRoupas(raiz, V, linhas, P);
      completaNavegacao(linhas);
    };
    const carrega = () => {
      if (!window.HitDados) return;
      window.HitDados.catalogo().then(desenha).catch(() => { /* A navegação e a vitrine Liquid permanecem disponíveis. */ });
    };
    quandoVisivel(raiz, carrega);
  }

  function inicia(onde) {
    $$('[data-home-hero]', onde).forEach((r) => { if (!iniciados.has(r)) { iniciados.add(r); heroes.set(r, hero(r)); } });
    $$('.home-news-form', onde).forEach((f) => { if (!iniciados.has(f)) { iniciados.add(f); newsletter(f); } });
    $$('.brand-bubbles,.home-slide-raquetes,.choice-guide', onde).forEach((r) => {
      if (!blocos.has(r)) blocos.set(r, r.matches('.brand-bubbles') ? bubbles(r) : r.matches('.home-slide-raquetes') ? campanhaRaquetes(r) : imagensDoBloco(r, '.choice-entry__media img'));
    });
    $$('[data-home-roupas]', onde).forEach((r) => { if (!iniciados.has(r)) { iniciados.add(r); iniciaRoupas(r); } });
    $$('[data-home-categorias]', onde).forEach((r) => {
      if (iniciados.has(r)) return;
      iniciados.add(r);
      quandoVisivel(r, () => {
        if (window.HitDados && window.HitConfig) window.HitDados.catalogo().then(completaNavegacao).catch(() => {});
      });
    });
    trilhos(onde);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => inicia(document)); else inicia(document);
  document.addEventListener('shopify:section:load', (e) => inicia(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    $$('[data-home-hero]', e.target).forEach((r) => { heroes.get(r)?.(); heroes.delete(r); iniciados.delete(r); });
    $$('.brand-bubbles,.home-slide-raquetes,.choice-guide', e.target).forEach((r) => { blocos.get(r)?.(); blocos.delete(r); });
  });
})();
